import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * Instagram Bridge Service
 *
 */
export const instagramService = (http, cookies) => ({
  /**
   * Get Instagram Bridge List
   *
   * @param {string} tagId article tag id
   * @param {string} page page number
   * @param {string} limit page number
   */
  async getArticles(tagId, page = 1, limit = 15) {
    const sort = 'igDate';
    const queryParams = encodeQuery({ tagId, page, limit, sort, author: true, categories: true, breadcrumb: true });
    const { data: result } = await http.get(`${base}/articles${queryParams}`);

    return result;
  },
});
